class Admin {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.email = data ? data.email : ''
    this.password = ''
    this.updated_at = data ? data.updated_at : ''
  }
}

export default Admin



// WEBPACK FOOTER //
// ./src/models/admin.js